module.exports = __webpack_public_path__ + "static/media/times.62ac776d.svg";